import { render, staticRenderFns } from "./cityForm.vue?vue&type=template&id=5a0ec712"
import script from "./cityForm.vue?vue&type=script&lang=js"
export * from "./cityForm.vue?vue&type=script&lang=js"
import style0 from "./cityForm.vue?vue&type=style&index=0&id=5a0ec712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports